
import { defineComponent, ref, reactive, provide, onMounted, toRefs, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import File from './components/File.vue'
import axios from '../../../../axios-vendor'
import { debounce } from 'lodash-es';
import Loader from '../components/Loader.vue'
import CommentList from './query/CommentList.vue'

export default defineComponent({
    components: {
        File,
        Loader,
        CommentList
    },
    props: {
        title: {
            type: String,
            default: 'Form',
        },
        id: {
            type: String,
            required: true
        },
    },

    setup(props) 
    {
        const loader_title = ref('Uploading')
        const loader_content = ref('Uploading and Sending Notification...')
        const visible_update_modal = ref(false);
        const deleted = ref(false)
        const loading = ref(false)

        const state = reactive({
            end_users: [],
            value: [],
            fetching: false,
        });

        const form = reactive({
            id:'',
            invoice_number: '',
            invoice_amount: '',
            invoice_description: '',
            end_user_id: '',
            user_id:'',
            vendor_id: window.localStorage.getItem('PAYMENT_PORTAL_VENDOR_ID') as any,
            invoice_files: [] as any,
            invoice_queries: [] as any,
            business_unit_id: '305afe76-e705-4bb8-a961-d85029df8c61'
        })

        const end_user_id = ref('');
        const end_user_is_changed = ref(false);

        provide('invoice', form)
        
        const name = ref('Invoice')

        const store = useStore()
        const router = useRouter()
        const form_action = ref()

        const handleChangeEndUser = () => {
            end_user_is_changed.value = false
        };

        const handleSearchEndUser = debounce(value => {
            state.end_users = [];
            state.fetching = false;
            form.end_user_id = ''
            if(isEmptyOrSpaces(value) == false) {
                fetchEndUser(value)
            }
        }, 500);

        const fetchEndUser = (value:any) => {
            state.fetching = true;
            const payload = {page: 1, search:value};
            store.dispatch('EndUser/index', payload).then((res) => {
                const data = res.data.data.map((user:any) => ({
                    label: user.full_name,
                    value: user.id,
                }));
                state.end_users = data;
                state.fetching = false;
            })
        };

        const isEmptyOrSpaces = (value:any) => {
            return value === null || value.match(/^ *$/) !== null;
        };
        
        const handleSaving = () => {
            !props.id ? storeRecord(): updateRecord()
        }

        const storeRecord = async () => {
            let api_url = process.env.VUE_APP_URL

            const headers = {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_VENDOR_TOKEN')}`
                }
            }
            const formData = new FormData();
            formData.append('invoice_number',form.invoice_number)
            formData.append('invoice_amount', form.invoice_amount)
            formData.append('invoice_description', form.invoice_description)
            formData.append('end_user_id', form.end_user_id)
          

            for (var i = 0; i < form.invoice_files.length; i++) {
                let file = form.invoice_files[i]
            
                formData.append('invoice_files[' + i + '][file]', file.file)
                formData.append('invoice_files[' + i + '][name]', file.name)
                formData.append('invoice_files[' + i + '][description]', file.description)
            
            }
            visible_update_modal.value = true;
            await axios.post(api_url + '/api/vendor_invoices/vendor',formData,headers).then(() => {
                visible_update_modal.value = false
                back()
                store.dispatch('VendorInvoice/index')
                store.dispatch('VendorInvoice/archive_lists')
            }).catch((err) => {
                visible_update_modal.value = false
                loading.value = false
            });
        }

        const updateRecord = () => {
            loadUpdating()
            const new_form = {...form}
            if(end_user_is_changed.value == true) {
                new_form.end_user_id = end_user_id.value
            }
            store.dispatch('VendorInvoice/update', new_form).then(() => {
                visible_update_modal.value = false,
                back()
                store.dispatch('VendorInvoice/index')
                store.dispatch('VendorInvoice/archive_lists')
            }).catch((err) => {
                loading.value = false
                visible_update_modal.value = false
            });
        }

        const showRecord = () => {
            store.dispatch('VendorInvoice/show',props.id).then((res) => {
                deleted.value = res.data.deleted_at ? true:false;
                form.id = res.data.id
                form.invoice_number = res.data.invoice_number
                form.invoice_amount = res.data.invoice_amount
                form.invoice_description = res.data.invoice_description
                form.end_user_id = res.data.user.full_name
                form.user_id = res.data.end_user_id
                form.invoice_files = res.data.invoice_files
                form.invoice_queries = res.data.invoice_queries
                end_user_id.value = res.data.end_user_id
                end_user_is_changed.value = true
            })
        }

        const restore = () => {
            loadUpdating()
            store.dispatch('VendorInvoice/restore',props.id).then(() => {
                loading.value = false 
                back()
            }).catch((err) => {
                loading.value = false
            });
        }
        
        const back = () => {
            router.push('/submitted/invoice');
        }

        const loadUpdating = () => {
            loading.value = true
            visible_update_modal.value = true
            loader_title.value = "Updating"
            loader_content.value = "Updating and Sending Notification..."
        }
       
        onMounted(() => {
            if(props.id){
                showRecord()
            }
        })

        watch(state.value, () => {
            state.end_users = [];
            state.fetching = false;
        });

        return {
            ...toRefs(state),
            handleChangeEndUser,
            handleSearchEndUser,
            form,
            name,
            back,
            handleSaving,
            visible_update_modal,
            loader_title,
            loader_content,
            deleted,
            restore,
            loading
        }
    }
})
